import { useSubnav } from '@ally/next-subnav'
import { useHostServices } from '../HostServices'

export const useDefaultSubnav = (): void => {
  const hostServices = useHostServices()

  useSubnav({
    hostServices,
  })
}

export const useNoSubnav = (): void => {
  const hostServices = useHostServices()

  useSubnav({
    hostServices,
    orderedSchema: [],
  })
}
